
export const supplyDemands = [
    { "id": "0", "value": "None" },
    { "id": "1", "value": "Kháng Cự - Hỗ Trợ" },
    { "id": "2", "value": "Đường xu hướng" },
    { "id": "3", "value": "Kênh giá" },
    { "id": "4", "value": "Vùng số tròn" }
]